export default function resolveCarVin(vin?: string) {
  if (typeof vin !== 'string') {
    return '';
  }

  // выводим vin в формате TSML*********3030
  const result = vin.split('').map((v, idx) => {
    if (idx < 4 || idx > vin.length - 5) {
      return v;
    }
    return '*';
  });

  return result.join('');
}
